import { z } from 'zod';

const DesignBoardUserMembershipSchema = z.enum(['owners', 'collaborators']);

export type CollaboratorAccessType = 'comment' | 'view' | 'edit';
export const permissionTypeLabels: { [key in CollaboratorAccessType]: string } =
    {
        edit: 'can edit',
        view: 'can view',
        comment: 'can comment',
    };
export const CollaboratorAccessEnumSchema = z
    .enum(['edit', 'comment', 'view'])
    .default('edit');
const InviteStatusEnumSchema = z.enum(['accepted', 'sent']);

export const CollaboratorSchema = z.object({
    name: z.string().min(1),
    inviteStatus: InviteStatusEnumSchema,
    profileImageUrl: z.string(),
    access: CollaboratorAccessEnumSchema,
    membership: DesignBoardUserMembershipSchema,
    email: z.string().email().optional(),
});

export const CollaboratorAccessEnumTitleMap: { [key: string]: string } = {
    comment: 'Can comment',
    view: 'Can view',
    edit: 'Can edit',
};
